// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"disclaimer_backgroundColor__AaerS","textClassName":"disclaimer_textClassName___xS5J","iconClassName":"disclaimer_iconClassName__67VqS"};